import React, { useEffect, useState } from 'react';
import { produce } from 'immer';
import Cell from '../board/Cell';
import './LoadingAnimation.css';


function randomTwoElements(items) {
  return [items[Math.floor(Math.random()*items.length)], items[Math.floor(Math.random()*items.length)]];
}

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const WORDS = [
  "XWING", "YAVIN", "SABER", "VADER", "EWOKS", "CLONE", "SITHS", "YWING",
  "FORCE", "WEDGE", "SANDY", "JEDIS", "MAULS", "NABOO", "PROBE", "GROGU",
  "JANGO", "REBEL", "GUARD", "BLADE", "STORM", "CHEWY", "GRIEV", "BWING",
  "DROID", "LIGHT", "FLEET", "KYBER", "MANDO", "SNOKE", "JAKKU", "SPICE",
  "WAMPA", "SCOUT", "PADME", "WATTO", "JABBA", "CLOUD", "HUTTS",
  "ENDOR", "ANDOR", "YODAS", "KRAYT", "DARTH", "ARTOO", "ROGER",
  "AKBAR", "REXES", "WOLFE", "RAIDS", "NOOOO", "BINKS", "YOUNG",
  "DOOKU", "TAUNT", "SHMIS", "BODHI", "TROOP", "SUPER", "LEGOS",
  "JEDHA", "OMEGA", "ROGUE", "ZORII", "SNIPS", "LUCAS", "C-3PO",
];



export default function LoadingAnimation({ size=20, ...props }) {

  const [cells, setCells] = useState(null);   // list of 10 { visible, letter } objects

  useEffect(() => {
    // Set initial state
    const initialArray = randomTwoElements(WORDS).join('').split('').map(c => ({ visible: true, letter: c.toUpperCase() }));
    setCells(initialArray);

    // Swap out a random one of these every so often
    const interval = setInterval(() => {
      setCells(oldCells => oldCells && produce(oldCells, draft => {
        const randomCell = draft[Math.floor(Math.random() * draft.length)];
        if (!randomCell.visible) randomCell.letter = ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
        randomCell.visible = !randomCell.visible;
      }));
    }, 100);

    // Cleanup
    return () => clearInterval(interval);
  }, []);



  return <div className='d-inline-block text-start' {...props}>
    <div className='animated-ellipsis ms-2 mb-4 block-text' style={{fontSize: 34 * size/20}}>Loading</div>

    {cells && <svg viewBox='0 0 100 40' width={size*10}>
      {cells.map(({visible, letter}, idx) => (
        <Cell
          className={visible ? 'fade-visible' : 'fade-invisible'}
          key={'loading-cell-' + idx}
          cellSize={20}
          row={idx <= 4 ? 0 : 1}
          col={idx % 5}
          cellContent={letter}
          strokeWidth={0.5}
        />
      ))}
    </svg>}
  </div>;
}